// Contenu éducatif détaillé pour les onglets stratégiques
export const CONTENT = {
  "warmup": {
    title: "Warm-Up Réseaux",
    subtitle: "Réchauffer un compte sans déclencher l'algorithme",
    intro: "Un compte mal warmé = reach plafonné dès le départ. Le warm-up est la fondation de tout scaling sérieux.",
    sections: [
      { title: "Différents types de comptes", items: [
        ["Compte neuf", "0 historique. Aucune action avant 48h. Profil 100% rempli avant tout."],
        ["Compte chauffé", "Historique stable, peut absorber +30% d'actions/jour sans risque."],
        ["Compte principal", "Branding fort. Quotas modérés. Priorité reach > engagement."],
        ["Compte spam", "Volume max. Espérance de vie courte. Toujours sacrifiable."],
        ["Compte shadowban", "Stop posts 7-14j. Reset comportement. Repart en warm-up doux."],
        ["Compte recovery", "Sortie de shadowban. 21 jours minimum de warm-up discret."],
      ]},
      { title: "Programmes de warm-up", items: [
        ["Warm-up 7 jours (rapide)", "J1-J2: scroll 30min/jour, 5 likes. J3-J4: 15 likes, 3 commentaires. J5-J7: 30 likes, 8 commentaires, 1 follow rare."],
        ["Warm-up 14 jours (sûr)", "Montée progressive. +20% d'actions par jour max. Premier post à J10 minimum."],
        ["Warm-up agressif", "Compte sacrifiable uniquement. +50%/jour. 80% taux de mort sous 30 jours."],
        ["Warm-up discret", "Compte sensible. Actions humaines uniquement, pauses aléatoires, varier les heures."],
        ["Warm-up récupération", "Post shadowban. Aucun post 10j. Engagement passif uniquement les 14 premiers jours."],
      ]},
      { title: "Erreurs qui détruisent la portée", items: [
        ["Poster trop vite", "Premier post avant J7 sur compte neuf = reach divisé par 5."],
        ["Liens en bio dès J1", "Triggers anti-spam IG. Toujours attendre J14."],
        ["Follow massif", "+50 follows/jour sur compte neuf = shadowban quasi garanti."],
        ["Commentaires copiés", "Anti-spam détecte la répétition. Varier sémantique systématiquement."],
        ["VPN + changement device", "Trigger ban pour comportement bot. Toujours device + IP stable."],
      ]},
    ]
  },
  "algo-instagram": {
    title: "Algorithme Instagram",
    subtitle: "Comment IG décide qui voit ton contenu",
    intro: "L'algorithme IG est une cascade de filtres. Chaque étape franchie = palier de reach. Comprendre la cascade = exploser ses vues.",
    sections: [
      { title: "Les 3 phases du push algo", items: [
        ["Phase 1 — Audience cold (0-200 vues)", "IG montre à 5-10% de tes followers actifs. Test silencieux. Watchtime + saves > likes."],
        ["Phase 2 — Audience tiède (200-5K)", "Push à audience similaire. Engagement rate > 4% nécessaire pour passer à phase 3."],
        ["Phase 3 — Explore / Reels feed", "Push à audience cold globale. Watchtime + shares = nitro."],
      ]},
      { title: "Signaux qui boostent le reach", items: [
        ["Watchtime ≥ 70%", "Le signal #1. Plus que likes/comments combinés."],
        ["Saves", "Coefficient x3 vs like. IG le perçoit comme valeur durable."],
        ["Shares en DM", "Coefficient x5. Le signal viral ultime."],
        ["Re-watch / loops", "Loop ultra court = re-watch automatique = signal premium."],
      ]},
      { title: "Signaux qui détruisent le reach", items: [
        ["Skip rate > 50%", "Tag immédiat 'low quality'. Reach plafonné définitivement."],
        ["Hashtags spammy", "#followforfollow #viral = -60% reach systémique."],
        ["Repost de contenu watermarké", "Detect TikTok/CapCut watermark = -40% push."],
        ["Captions trop longues sans hook", "Skip avant lecture = signal négatif."],
      ]},
    ]
  },
  "algo-tiktok": {
    title: "Algorithme TikTok",
    subtitle: "La machine virale la plus prédictible au monde",
    intro: "TikTok est le seul réseau qui peut mettre un compte à 0 abonné devant 1M de personnes. Sa logique est mathématique.",
    sections: [
      { title: "Les paliers TikTok", items: [
        ["200-500 vues (test cold)", "TikTok montre à 200 cold viewers. Si watchtime > 50%, push palier suivant."],
        ["1K-5K", "Audience similaire. Engagement rate ≥ 8% pour passer."],
        ["10K-100K", "Push géographique élargi. Shares = clé pour le palier suivant."],
        ["100K+", "FYP global. Loop + retention + commentaires actifs sont obligatoires."],
      ]},
      { title: "Boosters spécifiques TikTok", items: [
        ["Hook visuel 0-1s", "Mouvement à l'écran avant la voix. Stop le scroll."],
        ["Sons trending", "x2 reach automatique pendant la fenêtre 7-14 jours du son."],
        ["Loops invisibles", "Dernière frame = première frame. Re-watch = +200% watchtime."],
        ["Comments en cascade", "Réponses rapides + comment baits = signal hot."],
      ]},
    ]
  },
  "reels": {
    title: "Stratégie Reels",
    subtitle: "Le format à 80% du reach IG/Facebook",
    intro: "Trends + hooks + branding + storytelling + teasing = formule éprouvée à 90%+ de hit rate.",
    sections: [
      { title: "Pourquoi les trends explosent", items: [
        ["Boost natif algo", "IG pousse les sons trending pour valider sa propre fonctionnalité."],
        ["Pattern recognition", "Cerveau reconnait → confiance → watchtime."],
        ["Faible coût production", "Format prouvé, juste à adapter à ta niche."],
      ]},
      { title: "Pourquoi le contenu original est plus dur", items: [
        ["Pas de pattern reconnu", "Cerveau hésite, skip plus rapide."],
        ["Absence de boost natif", "Le son personnalisé n'est pas push par défaut."],
        ["Mais... reach plafond x10 si ça marche", "Original viral = signature, audience qualifiée."],
      ]},
      { title: "Mix gagnant", items: [
        ["70% trend adapté à ta niche", "Le carburant du compte."],
        ["20% storytelling original", "Construit la marque."],
        ["10% concepts expérimentaux", "Un d'eux peut exploser et redéfinir le compte."],
      ]},
    ]
  },
  "trends-strat": {
    title: "Stratégie Trends",
    subtitle: "Repérer, surfer, monétiser une trend en 48h",
    intro: "Une trend a une fenêtre de 5-10 jours. Arriver tôt = explosion. Arriver tard = noyé dans le bruit.",
    sections: [
      { title: "Détecter une trend tôt", items: [
        ["Compte spy à 100K-500K", "Sweet spot où les early-adopters poussent les sons."],
        ["TikTok Creative Center", "Sons en hausse <7 jours = fenêtre encore ouverte."],
        ["Hashtag #usethissound", "Si <5K vidéos, t'es dans la fenêtre."],
        ["Reels saved sans légende virale", "Indicateur que les créateurs testent en silence."],
      ]},
      { title: "Adapter à ta niche", items: [
        ["Garder le format, changer le sujet", "La structure trend + contenu spécifique = gold."],
        ["Hook custom dans les 0-1s", "Annoncer la valeur avant le drop."],
        ["CTA invisible en fin", "Pose une question — push commentaires."],
      ]},
    ]
  },
  "hooks-viraux": {
    title: "Hooks Viraux",
    subtitle: "0-1 seconde décide de tout",
    intro: "90% des skip se font dans la première seconde. Le hook n'est pas optionnel, c'est l'ENTIER du jeu.",
    sections: [
      { title: "Catégories de hooks puissants", items: [
        ["Curiosity Gap", "'Personne ne te dira ça mais...' → cerveau exige de savoir."],
        ["Controversy / Hot take", "'Arrête de poster avant d'avoir lu ça.' → tension instantanée."],
        ["Transformation", "'J'ai testé X pendant 30 jours.' → promesse de payoff."],
        ["Fear / Loss", "'Tu fais cette erreur sans le savoir.' → instinct de protection."],
        ["Value bomb", "'3 erreurs qui tuent ton reach (silencieusement).' → promesse claire."],
        ["Pattern interrupt", "Visuel choquant + question → arrêt scroll mécanique."],
      ]},
      { title: "Règles d'or", items: [
        ["Max 12 mots", "Au-delà = lu trop lentement = scroll."],
        ["Concret > abstrait", "'Mon reach a fait x10' bat 'j'ai fait croitre mon compte'."],
        ["Spécificité", "Un chiffre précis crée la crédibilité."],
        ["Tension non résolue", "Le payoff doit venir dans la vidéo, jamais dans le hook."],
      ]},
    ]
  },
  "storytelling": {
    title: "Storytelling",
    subtitle: "Les comptes à 1M sont des conteurs déguisés",
    intro: "L'info se zappe. L'histoire reste. Le storytelling transforme un viewer en fan.",
    sections: [
      { title: "Structure narrative virale", items: [
        ["Setup en 1 phrase", "Contexte ultra court. Pas de blabla."],
        ["Conflit ou tension", "Quelque chose va mal, ou un défi."],
        ["Action / révélation", "Ce que tu as fait, ou ce que tu as découvert."],
        ["Payoff + leçon", "Résolution + take-away pour le viewer."],
      ]},
      { title: "Techniques avancées", items: [
        ["In medias res", "Commencer au milieu de l'action. Hook automatique."],
        ["Cliffhanger", "Couper avant la résolution → save + revisit."],
        ["Vulnérabilité contrôlée", "Une faille humaine = +200% engagement."],
      ]},
    ]
  },
  "watchtime": {
    title: "Watchtime Optimization",
    subtitle: "Le signal le plus puissant de tous",
    intro: "Watchtime = combien de secondes tes viewers regardent. C'est le seul KPI qui compte vraiment pour l'algo.",
    sections: [
      { title: "Techniques de rétention", items: [
        ["Loops invisibles", "Dernière frame ≈ première frame → re-watch."],
        ["Promesses progressives", "'Tu vas pas croire ce qui arrive à 0:18'."],
        ["Cuts toutes les 1-2s", "Pattern interrupt visuel en continu."],
        ["Sous-titres dynamiques", "Mouvement constant à l'écran."],
        ["Open loop", "Question posée tôt, résolue tard."],
      ]},
      { title: "Dopamine visuelle", items: [
        ["Couleurs saturées", "Cerveau traite plus vite, attention captée."],
        ["Mouvement de caméra", "Statique = ennui. Mouvement = focus."],
        ["Texte qui apparaît", "Force la lecture, augmente attention."],
      ]},
    ]
  },
  "comment-baiting": {
    title: "Comment Baiting",
    subtitle: "Doubler son taux de commentaires en 48h",
    intro: "Les commentaires sont x2 plus puissants que les likes. Un commentaire bait stratégique = palier algo en plus.",
    sections: [
      { title: "Techniques psychologiques", items: [
        ["Question ouverte ciblée", "'Tu fais quoi en premier le matin ?' → réponse spontanée."],
        ["Erreur volontaire visible", "Faute typo ou détail faux → correction par les viewers."],
        ["Choix binaire polarisant", "'A ou B ?' → besoin de prendre position."],
        ["Hot take controversé", "'Le contenu original est mort.' → débat enclenché."],
        ["Inviter au tag", "'Tag celui qui doit voir ça' → viralité organique."],
      ]},
      { title: "Réponses stratégiques", items: [
        ["Répondre dans les 30min", "IG/TikTok tag le post comme 'hot' = push palier."],
        ["Réponse longue + question", "Crée chaîne de commentaires."],
        ["Liker tous les commentaires", "Boost taux de réponse retour."],
      ]},
    ]
  },
  "story": {
    title: "Story Strategy",
    subtitle: "Le canal proximité-engagement",
    intro: "Les stories ne donnent pas de reach. Elles donnent de la profondeur d'audience. Indispensable pour la fidélisation.",
    sections: [
      { title: "Types de stories à mixer", items: [
        ["Sondages", "+200% interaction. Algo IG kiff."],
        ["Questions ouvertes (sticker Q)", "Goldmine de contenu reels à venir."],
        ["Lifestyle / coulisses", "Crée la proximité parasociale."],
        ["Teasing reels à venir", "Augmente CTR sur les futurs posts."],
        ["Témoignages / DMs reçus", "Social proof gratuit."],
      ]},
      { title: "Cadence", items: [
        ["3-7 stories/jour", "Trop = désaboo. Pas assez = oubli."],
        ["Première story = hook", "Comme un reel : capter dans les 1s."],
        ["Dernière = CTA", "Lien, sondage, question."],
      ]},
    ]
  },
  "engagement": {
    title: "Engagement System",
    subtitle: "Système d'engagement quotidien automatisable",
    intro: "L'engagement n'est pas une activité, c'est un système. 90 minutes / jour bien structurées = scaling garanti.",
    sections: [
      { title: "Routine engagement (3 sessions de 30min)", items: [
        ["Session 1 — Réveil (matin)", "Répondre DMs, liker stories audience cible, 15 commentaires de valeur."],
        ["Session 2 — Push (midi)", "Commentaires sous gros comptes de la niche, follow audiences hot."],
        ["Session 3 — Lock (soir)", "Réponses commentaires de tes posts du jour, DMs nouvelle audience."],
      ]},
      { title: "Quotas safe", items: [
        ["Likes: 80-150/jour", "Au-delà = trigger anti-spam."],
        ["Commentaires: 30-60/jour", "Avec variation sémantique."],
        ["Follows: 15-30/jour", "Plus = ban risk."],
        ["DMs: 10-25/jour", "Personnalisés obligatoires."],
      ]},
    ]
  },
  "dm": {
    title: "DM Strategy",
    subtitle: "Le canal underrated qui transforme",
    intro: "Les DMs sont le canal direct n°1. Bien utilisé = leads, partenariats, ventes. Mal utilisé = ban.",
    sections: [
      { title: "Templates DM ouverture", items: [
        ["Cold value-first", "Compliment précis + valeur gratuite. Pas de pitch."],
        ["Question ciblée", "Question intelligente sur leur contenu → réponse."],
        ["Vocaux > texte", "+300% taux de réponse vs texte plat."],
      ]},
      { title: "Limites de sécurité", items: [
        ["Compte neuf: 0 DM cold avant J21", "Sinon ban quasi garanti."],
        ["Compte chauffé: 20-30 DMs cold/jour max", "Personnaliser obligatoirement."],
        ["Pas de liens en premier message", "Triggers anti-spam IG."],
      ]},
    ]
  },
  "threads": {
    title: "Threads Strategy",
    subtitle: "Le réseau gratuit où le reach est 10x facile",
    intro: "Threads en 2026 = ce que Twitter était en 2010. Un compte à 0 abonné peut faire 100K vues facilement.",
    sections: [
      { title: "Formats qui cartonnent", items: [
        ["Hot take court", "1-2 phrases polarisantes. Pas plus."],
        ["Liste numérotée value", "5 trucs que personne ne te dit sur X."],
        ["Question rhétorique punchy", "Pousse à répondre."],
        ["Quote tweet de soi-même", "Continuation de thought."],
      ]},
      { title: "Routine traffic gratuit", items: [
        ["10 réponses/jour sous gros posts", "Réponse first 30min après post du gros = goldmine."],
        ["Toujours apporter de la valeur", "Pas de 'd'accord +1'. Always add edge."],
        ["Lien IG/TikTok dans bio", "Conversion gratuite."],
      ]},
    ]
  },
  "x-twitter": {
    title: "X / Twitter Strategy",
    subtitle: "Le réseau pour les opinions tranchées",
    intro: "X = arène d'opinions. Le mou meurt. Le tranché explose. Pas de neutralité possible.",
    sections: [
      { title: "Formats viraux 2026", items: [
        ["Thread structure 8-12 tweets", "Hook + payoff par tweet + CTA fin."],
        ["Quote tweet réaction", "Réagir à un tweet viral avec angle unique."],
        ["Poll polarisant", "Force la prise de position."],
      ]},
      { title: "Hooks textuels", items: [
        ["'Hot take:'", "Signal direct = position tranchée à venir."],
        ["'Personne ne te dira ça:'", "Curiosity gap textuel."],
        ["'En 2026, les X qui font Y vont mourir.'", "Prédiction = engagement."],
      ]},
    ]
  },
  "shorts": {
    title: "Youtube Shorts",
    subtitle: "Le format avec le watchtime le plus long",
    intro: "YT Shorts = audience plus mature, watchtime plus long, monétisable. À ne pas négliger.",
    sections: [
      { title: "Différences avec Reels/TikTok", items: [
        ["Audience plus mature 25-45", "Tolère contenu plus long et éducatif."],
        ["Watchtime moyen plus haut", "60% vs 35% sur TikTok."],
        ["Monétisation directe", "RPM Shorts = $0.05-$0.30/1000 vues."],
      ]},
      { title: "Optimisation YT spécifique", items: [
        ["Titre + description SEO", "Mots-clés pour le SEO YT."],
        ["Thumbnail custom", "Même sur Shorts, ça compte."],
        ["Cross-post Reels avec watermark retiré", "Sinon -40% reach."],
      ]},
    ]
  },
  "clapper": {
    title: "Clapper Strategy",
    subtitle: "Le réseau émergent à exploiter en 2026",
    intro: "Clapper a une audience plus âgée, moins saturée. Les early creators y dominent encore.",
    sections: [
      { title: "Pourquoi y aller", items: [
        ["Reach organique 5-10x supérieur", "Plateforme jeune, peu de créateurs."],
        ["Audience 35-65", "Pouvoir d'achat élevé."],
        ["Découverte boostée des nouveaux comptes", "Algo favorise les newcomers."],
      ]},
    ]
  },
  "snap": {
    title: "Snap Strategy",
    subtitle: "Le canal Gen Z direct",
    intro: "Snap Spotlight push agressivement le contenu fun et raw. Pas du tout sur-saturé.",
    sections: [
      { title: "Spotlight = TikTok-like", items: [
        ["Reach gratuit important", "Snap paye encore certains créateurs."],
        ["Audience 13-24 ultra engagée", "Conversion DM élevée."],
        ["Format vertical 9:16 obligatoire", "Pas de débordement."],
      ]},
    ]
  },
  "scaling": {
    title: "Scaling de Comptes",
    subtitle: "Passer de 1 à 10 comptes sans flammes",
    intro: "Scaler = multiplier l'output sans multiplier le risque. Ça demande système, pas effort.",
    sections: [
      { title: "Ordre de scaling", items: [
        ["Compte 1 valide à 50K", "Avant tout scaling, valider la formule sur 1 compte."],
        ["Compte 2 = clone branding différent", "Même contenu, branding différent."],
        ["Compte 3 = niche adjacente", "Audience similaire mais distincte."],
        ["Compte 4+ = expérimentation", "Testing pure."],
      ]},
      { title: "Vitesse de scaling sécurisée", items: [
        ["1 compte/mois max", "Plus = warm-up bâclé = mortalité."],
        ["+1 compte par 50K abos validé", "Le succès finance la prise de risque."],
      ]},
    ]
  },
  "shadowban": {
    title: "Shadowban & Sécurité",
    subtitle: "Détecter, sortir, prévenir",
    intro: "Shadowban = reach divisé par 10-100 sans notif. La majorité des créateurs sont ban sans le savoir.",
    sections: [
      { title: "Détecter un shadowban", items: [
        ["Reach divisé par 5+ d'un coup", "Sans changement de contenu = ban."],
        ["Hashtags qui n'apparaissent plus", "Test : poste avec hashtag niche, vérifie si visible."],
        ["Profil non suggéré dans Explore", "Disparition de Suggested = ban léger."],
      ]},
      { title: "Sortir d'un shadowban", items: [
        ["Stop posts 7-14 jours", "Reset comportement compte."],
        ["Désactiver compte 3 jours", "Reset profond. Le plus efficace."],
        ["Reprendre en warm-up doux", "21 jours minimum, jamais brusque."],
      ]},
      { title: "Prévention", items: [
        ["Pas plus de 200 actions/jour", "Total likes+comments+follows."],
        ["Variation horaires", "Bot detect les patterns fixes."],
        ["Pas de hashtags bannis", "Liste à vérifier mensuellement."],
      ]},
    ]
  },
  "team": {
    title: "Gestion d'Équipe",
    subtitle: "Du solo à la machine de production",
    intro: "Pas de scaling sans équipe. Une équipe bien rodée = 5x output, 1x effort fondateur.",
    sections: [
      { title: "Rôles essentiels", items: [
        ["Editor vidéo", "Ratio 1 editor / 4 reels par jour."],
        ["Community Manager", "Gère DMs + commentaires + stories."],
        ["Growth Strategist", "Spy concurrence, KPIs, A/B testing."],
        ["Hook writer", "Banque de hooks, captions."],
      ]},
      { title: "Process", items: [
        ["Brief écrit pour chaque vidéo", "Hook, structure, CTA, format."],
        ["Review fondateur < 24h", "Bottleneck à éviter absolument."],
        ["Tableau Notion / Trello", "Pipeline visible par tous."],
      ]},
    ]
  },
  "organisation": {
    title: "Organisation du Contenu",
    subtitle: "De l'idée au post en moins de 24h",
    intro: "Sans système d'organisation, tu re-réfléchis chaque jour. Système = output prédictible.",
    sections: [
      { title: "Pipeline standard", items: [
        ["1. Banque d'idées", "Document central toujours alimenté."],
        ["2. Sélection hebdo", "Lundi: choix des 7-15 contenus de la semaine."],
        ["3. Tournage batch", "1-2 sessions / semaine, jamais à l'unité."],
        ["4. Edit + scheduling", "Traité à part."],
      ]},
      { title: "Outils", items: [
        ["Notion / Airtable", "Base de données content."],
        ["Frame.io / Drive", "Review vidéo asynchrone."],
        ["Buffer / Metricool", "Scheduling cross-plateformes."],
      ]},
    ]
  },
  "automation": {
    title: "Automation Réseaux",
    subtitle: "Automatiser sans déclencher l'algo",
    intro: "L'automation pure = ban garanti. L'automation hybride humaine = scaling x5.",
    sections: [
      { title: "À automatiser sans risque", items: [
        ["Scheduling de posts", "100% safe. Buffer / Metricool."],
        ["Réponses DM via templates", "Avec déclencheur humain."],
        ["IA pour hooks / captions / idées", "Brainstorming x10 plus rapide."],
        ["Analyse KPIs", "Dashboards automatiques."],
      ]},
      { title: "À ne JAMAIS automatiser", items: [
        ["Likes / follows / DMs cold", "Ban quasi garanti sous 7-30 jours."],
        ["Comments génériques", "Detection bot facile."],
      ]},
    ]
  },
  "errors": {
    title: "Erreurs Fatales",
    subtitle: "Ce qui tue silencieusement les comptes",
    intro: "La majorité des comptes ne meurent pas d'un manque de talent. Ils meurent d'erreurs invisibles répétées.",
    sections: [
      { title: "Top 10 erreurs fatales", items: [
        ["Posts trop fréquents en début", "+3/jour sur compte neuf = chute reach."],
        ["Watermark TikTok/CapCut sur Reels", "-40% push systémique."],
        ["Hashtags spammy", "#followforfollow = -60%."],
        ["Pas de hook 0-1s", "70% de skip immédiat."],
        ["Réponses tardives commentaires", ">2h = signal froid."],
        ["Captions trop longues sans hook", "Skip avant lecture."],
        ["Posts à heures aléatoires", "Algo construit le rythme du compte."],
        ["Niche trop large", "Algo ne sait pas qui te montrer."],
        ["Pas de A/B testing", "Tu optimises à l'aveugle."],
        ["Suivi KPI pifométrique", "Sans data, pas de growth."],
      ]},
    ]
  },
  "tests": {
    title: "Système de Tests",
    subtitle: "A/B testing systématique",
    intro: "Sans tests, tu construis sur des suppositions. Avec tests, tu construis sur des faits.",
    sections: [
      { title: "Variables à tester", items: [
        ["Hook (variantes A/B)", "Même contenu, hook différent → meilleur reach gagne."],
        ["Format (vertical / carrousel / story)", "Lequel performe le mieux pour ta niche."],
        ["CTA (lien / commentaire / DM)", "Lequel convertit le plus."],
        ["Heure de post", "Sweet spot dépend de ton audience."],
      ]},
      { title: "Méthodologie", items: [
        ["Une variable à la fois", "Sinon résultat ininterprétable."],
        ["Minimum 5 essais par variable", "Une seule donnée = biais."],
        ["Tracking obligatoire", "Sheet ou Notion."],
      ]},
    ]
  },
  "growth-hacking": {
    title: "Growth Hacking",
    subtitle: "Les hacks que personne ne partage",
    intro: "Le growth hacking n'est pas magique. C'est la combinaison de petits leviers cumulés.",
    sections: [
      { title: "Hacks reach", items: [
        ["Repost sur compte secondaire", "+30% de reach total avec 0 effort."],
        ["Cross-post Threads dans les 5 min", "Push synchronisé = double signal."],
        ["Story du Reel 1h après publication", "Boost watchtime du Reel."],
      ]},
      { title: "Hacks engagement", items: [
        ["Première vue dans les 5 minutes", "Demander à 5 followers proches → boost initial."],
        ["Réponses commentaires en cluster", "Toutes en 30min = signal hot."],
        ["Save personnel via compte secondaire", "Save = signal x3."],
      ]},
    ]
  },
  "branding": {
    title: "Branding Personnel",
    subtitle: "Devenir reconnaissable en 3 secondes",
    intro: "Une marque forte = reach durable. Sans branding, t'es interchangeable. Avec branding, t'es irremplaçable.",
    sections: [
      { title: "Piliers du branding personnel", items: [
        ["Visual signature", "Couleur dominante, font, format. Reconnaissable instantanément."],
        ["Voix unique", "Choix vocabulaire, ton, angle. Pas générique."],
        ["Niche précise", "1 niche dominante + 1 niche adjacente max."],
        ["Storytelling personnel", "Ton 'why', tes failles, ta progression."],
      ]},
      { title: "Tests rapides", items: [
        ["Black-out test", "Cache ton visage et ton @. On te reconnait à la voix / style ?"],
        ["3 secondes test", "Un viewer voit ton post 3s. Sait-il qui tu es ?"],
      ]},
    ]
  },
};
